import React from "react";

export default function EmptyInboxIcon({ size = '16px', color = 'var(--gray-500)' }) {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1010_1219)">
            <path d="M46.6673 30.3333V13.9999C46.6673 11.4226 44.578 9.33325 42.0006 9.33325H14.0007C11.4233 9.33325 9.33398 11.4226 9.33398 13.9999V30.3333M46.6673 30.3333V41.9999C46.6673 44.5772 44.578 46.6666 42.0006 46.6666H14.0007C11.4233 46.6666 9.33398 44.5772 9.33398 41.9999V30.3333M46.6673 30.3333H40.6338C40.015 30.3333 39.4215 30.5791 38.9839 31.0167L33.3507 36.6498C32.9132 37.0874 32.3197 37.3333 31.7008 37.3333H24.3005C23.6816 37.3333 23.0882 37.0874 22.6506 36.6498L17.0174 31.0167C16.5798 30.5791 15.9863 30.3333 15.3675 30.3333H9.33398" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_1010_1219">
                <rect width="56" height="56" rx="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
  );
};
